import { MainStateService } from './../../core/app/common/main-state.service';
import { VideoPlayerService } from 'src/core/app/aro/components/videos/video-player-window/video-player.service';
import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AroSensorCoreComponent } from '@core_n/aro/aro-sensor-core.component';
import { AroService } from '@core_n/aro/aro.service';
import * as utils from '@core_n/common/utils';
import { MsgBoxService } from '@core_n/msg-boxes/msg-box.service';
import { AnalyticsMngrService } from '@core_n/msg/analytics-mngr.service';
import { SoundMsgMngrService } from '@core_n/msg/sound-msg-mngr.service';
import { VideoMsgMngrService } from '@core_n/msg/video-mngr.service';
import { SensorObject } from '../asp/SensorObject';
import { AroSensorTabDetailsComponent } from './aro-sensor-tab-details.component';

@Component({
  templateUrl: '../../core/app/aro/aro-sensor-core.component.html',
  styleUrls: ['../../core/app/aro/aro.component.scss']
})

export class AroSensorComponent extends AroSensorCoreComponent {

  constructor(public dialogRef: MatDialogRef<AroSensorComponent>,
    //private userActionSrv: UserActionService,
    elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) data: any,
    aroService: AroService,
    cdref: ChangeDetectorRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    fb: FormBuilder, protected msgBox: MsgBoxService,
    protected soundService: SoundMsgMngrService,
    protected videoService: VideoPlayerService,
    public analyticsMngrService: AnalyticsMngrService,
    protected videomngr: VideoMsgMngrService,
    protected mainStateService: MainStateService
    ) {
    super(aroService, cdref, elementRef, dialogRef, fb, msgBox, soundService, videoService, analyticsMngrService, videomngr, mainStateService);
  }

  protected getTabComponentFactory(tabIndex: number) {

    switch (tabIndex) {
      case 2:
        return this.componentFactoryResolver.resolveComponentFactory(AroSensorTabDetailsComponent);

      default:
        return null
    }
  }

  protected refresh(): void {
    super.refresh();
  }

  protected onShowAro() { }

  setSensor(sensor: SensorObject) {
    this.sensor = sensor;
    this.shown = true;
    this.refresh();
  }

  static createDialogConfig(sensor: SensorObject) {
    let dialogConfig = utils.createDialogConfig(false);
    dialogConfig.data = { sensor: sensor };
    return dialogConfig;
  }
}
